// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLEROPEDIA_NEW_ARTICLES = "Najnov\u0161ie \u010dl\u00e1nky";
